import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import { BrowserRouter } from "react-router-dom";
import CustomThemeProvider from './theme/themeContext';
import { AuthProvider } from './theme/AuthContext';
import { ResumeProvider } from './ResumeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <CustomThemeProvider>
          <CssBaseline />
          <ResumeProvider>
          <App />
          </ResumeProvider>
        </CustomThemeProvider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
